import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/utils'

export const FigureValue = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'p'>) => (
  <p
    className={cn(
      'text-2xl font-semibold tabular-nums tracking-tight text-blue-7',
      className,
    )}
    {...props}
  />
)
